/*
 *    Objects
 */
import { imageObject } from '@/algolia/templates/objects.js';
import metaText from '@/algolia/templates/searchMeta.js';

import { infiniteHits } from 'instantsearch.js/es/widgets';

// https://www.algolia.com/doc/api-reference/widgets/infinite-hits/js/
export default infiniteHits({
	container: '#AlgoliaResults',
	cssClasses: {
		root: 'text-center', // for pagination btn
		emptyRoot: '',
		list: 'text-left',
		item: 'border-b border-black/30',
		loadMore: ['o-btn', 'mt-16', ' lg:mt-28'],
	},
	templates: {
		item(hit) {
			const meta = metaText(hit);

			return `<article class="flex items-center relative w-full group/card  py-[30px] lg:py-5 c-card--${
				hit.type
			}">
			
			  <a href="${hit.url}"
			  title="View ${hit.title}"
			  class="absolute inset-0 z-40 w-full h-full">
			</a>

        ${
					hit.leadImage
						? `<div class="w-[85px] mr-5  flex-shrink-0 lg:w-[120px]">${imageObject(
								hit.leadImage
						  )}</div>`
						: ''
				}

        <div class="flex grow lg:justify-between flex-wrap lg:flex-no-wrap">
          <div class="w-full lg:w-auto mb-5 lg:mb-0">
            ${
							hit.title
								? `<h3 class="text-base font-body transition-colors duration-150  group-focus/card:text-black/50 group-hover/card:text-black/50">${hit.title}</h3>`
								: ''
						}

						${meta ? `<span class="inline-block text-sm text-black/50">${meta}</span>` : ''}

          </div>
        </div>
      </article>`;
		},
		empty(results) {
			// NO 'html' wraps as it breaks markup... This one we just want raw
			const hasSearchValue = `<div class="text-left relative w-full o-wysiwyg pt-[30px] lg:pt-0"><p>There aren't any results for "<span class="font-bold">${results.query}</span>".<br> Please try again.</p></div>`;
			const noSearchValue =
				'<div class="text-left relative w-full o-wysiwyg"><p>There aren\'t any results.<br> Please try again.</p></div>';

			return results.query.length ? hasSearchValue : noSearchValue;
		},
		showMoreText() {
			return 'Load more';
		},
	},
});
